// extracted by mini-css-extract-plugin
export var carrierIcon = "_ux-0";
export var carrierLogo = "_ux-1";
export var detailsSection = "_ux-2";